"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var shortcut_plugin_1 = require("./shortcut-plugin");
function textMarkShortcut(regexp, name, config) {
    return new shortcut_plugin_1.TextShortcut(name, regexp, function (view, state, match, start, end) {
        var _ = match[0], contentText = match[1];
        var mark = state.schema.marks[name];
        var attrs = shortcut_plugin_1.getShortcutAttrs(config.handler, view, match, start, end);
        var stashMark = view.state.doc.resolve(start).marks();
        if (!attrs)
            return null;
        var tr = state.tr;
        // 新增mark，保留原来的mark，插入空格是为了不输入时不应用新增mark
        tr.delete(start, end).insert(start, [
            state.schema.text(contentText, __spreadArrays([mark.create(attrs)], stashMark)),
            state.schema.text('\u0020', stashMark)
        ]);
        return tr;
    }, config);
}
exports.textMarkShortcut = textMarkShortcut;
//# sourceMappingURL=text-mark-shortcut.js.map